export default "__VITE_ASSET__Bm7u5xxZ__"